import type { SVGProps } from "react";
export interface Link02IconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Link02Icon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Link02IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12.413 3.372a5.816 5.816 0 0 1 8.008.207l.207.216a5.816 5.816 0 0 1-.207 8.009l-2.378 2.38a5.865 5.865 0 0 1-8.075.208l-.22-.208-.439-.44-.078-.086a1.125 1.125 0 0 1 1.584-1.583l.085.077.44.44.275.249a3.613 3.613 0 0 0 4.835-.25l2.38-2.378.245-.271a3.567 3.567 0 0 0-5.017-5.017l-.27.244-.993.992a1.125 1.125 0 1 1-1.59-1.59l.991-.992z"
      />
      <path
        fill={color}
        d="M6.177 9.608a5.865 5.865 0 0 1 8.075.208l.439.44.078.086a1.125 1.125 0 0 1-1.584 1.583l-.085-.077-.44-.44a3.614 3.614 0 0 0-4.836-.249l-.274.25-2.38 2.378a3.566 3.566 0 0 0 0 5.043l.27.245a3.567 3.567 0 0 0 4.773-.244l.992-.992a1.125 1.125 0 1 1 1.59 1.59l-.991.992a5.816 5.816 0 0 1-8.009.207l-.216-.207a5.816 5.816 0 0 1 0-8.225l2.379-2.38z"
      />
    </svg>
  );
}
